module.exports = __webpack_public_path__ + "img/percent.44e5a5ac.svg";